module.exports = __webpack_public_path__ + "img/tuition.943d451b.png";